import { Autocomplete } from '@base-ui/react/autocomplete';
import { Icon } from '@petsmart-ui/sparky';
import type { ComponentProps } from 'react';

import type { AssistedResultItem, SearchResultItem } from '../../../search.types';

type SearchResultAssistButtonClickHandler = NonNullable<ComponentProps<typeof Autocomplete.Item>['onClick']>;
type SearchResultAssistButtonMouseUpHandler = NonNullable<ComponentProps<typeof Autocomplete.Item>['onMouseUp']>;

type SearchResultAssistButtonProps = {
    onResult: (result: SearchResultItem) => void;
    result: AssistedResultItem;
};

export function SearchResultAssistButton({ onResult, result }: Readonly<SearchResultAssistButtonProps>) {
    const handleClick: SearchResultAssistButtonClickHandler = event => {
        event.preventBaseUIHandler();
        onResult(result);
    };
    const handleMouseUp: SearchResultAssistButtonMouseUpHandler = event => {
        event.preventBaseUIHandler();
    };

    return (
        <Autocomplete.Item
            aria-label={`Complete search with ${result.item.label}`}
            className="header-search__assisted-cell"
            onClick={handleClick}
            onMouseUp={handleMouseUp}
            tabIndex={-1}
            value={result}
        >
            <button
                aria-label={`Complete search with ${result.item.label}`}
                className="header-search__assisted-button"
                tabIndex={-1}
                type="button"
            >
                <Icon name="navigation-arrow" aria-hidden="true" />
            </button>
        </Autocomplete.Item>
    );
}
